import { bidsActionTypes } from './action-types'
import { BID_PAGINATION_SIZE } from './utils'

export const initialState = {
  bids: [],
  loading: false,
  error: null,
  hasMore: true,
  page: 1,
}

export const bidsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case bidsActionTypes.FETCH_BIDS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      }
    case bidsActionTypes.FETCH_BIDS_SUCCESS:
      return {
        ...state,
        loading: false,
        bids: payload.page > 1 ? [...state.bids, ...payload.data] : payload.data,
        page: payload.page,
        hasMore: payload.data.length >= BID_PAGINATION_SIZE,
      }
    case bidsActionTypes.FETCH_BIDS_FAILURE:
      return {
        ...state,
        loading: false,
        error: payload,
      }
    default:
      return state
  }
}
